import {Link} from "react-router-dom";

export default function Shops()
{
    return (<section className="shops">
        <div className="container-fluid">
            <div className="row">
                <div className="col">
                    <div className="banner">
                        <picture className="banner__img">
                            <source srcSet="img/temp/shops-mob.jpg" media="(max-width: 992px)" />
                                <img src="/img/temp/shops.jpg" alt="" />
                        </picture>
                        <h1 className="banner__title f-exp">Магазины</h1>
                        <p className="banner__text">Найти ближайший магазин BAON в России и СНГ</p>
                        <Link className="btn btn-primary" to={'/shops'}>Подробнее</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>)
}